import isMobileLayout from '../utils/isMobileLayout';
import { useEffect, useState } from 'react';
function FolderTabsBar({
  activeTab,
  setActiveTab
}) {
  const [isMobile, setIsMobile] = useState(isMobileLayout);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(isMobileLayout());
    };

    checkMobile();

    window.addEventListener('resize', checkMobile);

    return () => {
      window.removeEventListener('resize', checkMobile);
    };
  }, []);
const tabs = [
  { id: 'eventos', label: 'EVENTOS', mobileLabel: 'Eventos', icon: '🔔' },
  { id: 'geocercas', label: 'GEOCERCAS', mobileLabel: 'Geo', icon: '📍' },
  { id: 'historico', label: 'HISTÓRICO', mobileLabel: 'Hist.', icon: '🕒' },
  { id: 'rastreo', label: 'RASTREO', mobileLabel: 'Rastreo', icon: '🎯' },
  { id: 'informes', label: 'INFORMES', mobileLabel: 'Info', icon: '📄' }
];

 if (isMobile) {
  return (
    <div style={styles.mobileWrapper}>
      <div style={styles.mobileTabsBar}>
        {tabs.map((tab) => {
          const active = activeTab === tab.id;

          return (
    <button
  key={tab.id}
  onClick={() => setActiveTab(tab.id)}
  style={{
    ...styles.mobileTab,
    ...(active ? styles.mobileTabActive : {})
  }}
>
  <span style={styles.mobileIcon}>
    {tab.icon}
  </span>

  <span style={styles.mobileLabel}>
    {tab.mobileLabel}
  </span>
</button>
          );
        })}
      </div>
    </div>
  );
}

  return (
    <div style={styles.wrapper}>
      <div style={styles.tabsBar}>
        {tabs.map((tab) => {
          const active = activeTab === tab.id;

          return (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              style={{
                ...styles.tab,
                ...(active ? styles.tabActive : {})
              }}
            >
             <span
  style={{
    display: 'flex',
    alignItems: 'center',
    gap: '5px'
  }}
>
  <span>{tab.icon}</span>
  <span>{tab.label}</span>
</span>
              <div
                style={{
                  ...styles.notch,
                  ...(active ? styles.notchActive : {})
                }}
              />
            </button>
          );
        })}
      </div>
    </div>
  );
}

const styles = {
 wrapper: {
  position: 'absolute',
  top: '60px',
  left: '46%',
  right: '18px',
  height: '32px',
  zIndex: 3600,
  display: 'flex'
},

tabsBar: {
  width: '100%',
  height: '32px',
  gap: '4px',
  display: 'flex',
  justifyContent: 'flex-end',
  borderTop: 'none',
  borderBottom: 'none',
  background: 'transparent'
},

tab: {
  position: 'relative',
  height: '28px',
  minWidth: '84px',
  margin: 0,
  marginLeft: '0px',
  padding: '0 10px',
  border: '1px solid rgba(56,189,248,0.24)',
  borderTop: 'none',
  borderBottom: 'none',
  borderRadius: '0 0 8px 8px',
  background:
    'linear-gradient(180deg, #0d3570 0%, #061f49 100%)',
  color: '#dbeafe',
  fontSize: '9px',
  fontWeight: '900',
  letterSpacing: '0.55px',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  boxShadow:
    'inset 0 1px 0 rgba(255,255,255,0.08)'
},

tabActive: {
  background:
    'linear-gradient(180deg, #075fbf 0%, #073b83 48%, #061f49 100%)',
  color: '#ffffff',
  borderColor: 'rgba(125,211,252,0.58)',
  boxShadow:
    '0 0 16px rgba(14,165,233,0.32), inset 0 1px 0 rgba(255,255,255,0.12)',
  transform: 'translateY(2px)'
},

notch: {
  position: 'absolute',
  bottom: '-7px',
  right: '14px',
  width: '24px',
  height: '8px',
  background:
    'linear-gradient(180deg, #061f49 0%, #051632 100%)',
  clipPath:
    'polygon(0 0, 100% 0, 82% 100%, 24% 100%)',
  borderRadius: '0 0 4px 4px'
},

notchActive: {
  background:
    'linear-gradient(180deg, #061f49 0%, #075fbf 100%)',
  boxShadow:
    '0 0 10px rgba(56,189,248,0.62)'
},
mobileWrapper: {
  position: 'fixed',
  left: '0',
  right: '0',
  bottom: '0',
  height: '58px',
  zIndex: 9200,
  padding: '6px 5px 6px 5px',
  boxSizing: 'border-box',
  background:
    'linear-gradient(180deg, rgba(3,27,61,0.96), rgba(2,20,38,0.98))',
  borderTop: '1px solid rgba(96,165,250,0.22)',
  boxShadow: '0 -14px 36px rgba(2,8,23,0.38)'
},
mobileTabsBar: {
  width: '100%',
  height: '46px',
  display: 'flex',
  gap: '4px',
  justifyContent: 'space-between',
  overflowX: 'hidden',
  overflowY: 'hidden'
},

mobileTab: {
  flex: 1,
  height: '46px',
  minWidth: '0',
  borderRadius: '12px',
  border: '1px solid rgba(56,189,248,0.18)',
  background:
    'linear-gradient(180deg, #0d3570 0%, #061f49 100%)',
  color: '#dbeafe',
  cursor: 'pointer',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '0',
  gap: '1px'
},
mobileTabActive: {
  background:
    'linear-gradient(180deg, #075fbf 0%, #073b83 48%, #061f49 100%)',
  color: '#ffffff',
  borderColor: 'rgba(125,211,252,0.58)',
  boxShadow: '0 0 16px rgba(14,165,233,0.32)'
},
mobileIcon: {
  fontSize: '15px',
  lineHeight: '15px'
},

mobileLabel: {
  marginTop: '3px',
  fontSize: '7px',
  lineHeight: '8px',
  fontWeight: '900',
  color: '#ffffff'
}
};

export default FolderTabsBar;